'use strict';

angular.module('ClinicApp').factory('PrimeInvoiceService', function($http, ClinicConfig) {
  return {
    getBillableEntityPeriodMap: (modelType, modelId) => {
      return $http.get(ClinicConfig.HOSTNAME + `/prime/${modelType}/${modelId}/billableEntity`, {
        cache: true,
      }).then((response) => response.data);
    },

    getBillableEntity: (modelType, modelId, year, month) => {
      return $http.get(ClinicConfig.HOSTNAME + `/prime/${modelType}/${modelId}/billableEntity/${year}/${month}`)
        .then((response) => response.data);
    },
  };
});
